<template>
  <div id="app">
    <Nav v-if="$route.name!='Orders'&&$route.name!='Dashboard'&&$route.name!='Onboard'&&$route.name!='Performance'"></Nav>
    <router-view style="margin-top: 6rem;"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'

export default {
  name: 'App',
  components: {
    Nav
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

.nav-button {
  position: fixed;
  left: 0;
  height: 100%;
  width: 1rem;
}

.nav-button-icon {
  position: fixed;
  left: 0;
  bottom: 50%;
}

.right-nav {
  border-left: 1px solid gray;
  height: calc(100vh);
}

a.nav-link {
  color: black !important;
}

.nav-item.active {
  font-weight: bold;
  text-decoration: underline;
}


</style>
